<template>
    <div>
        <Breadcrumbs />
        <b-card style="min-height: 85vh !important;">
            <b-tabs v-model="tabIndex" card>
                <b-tab :title="$t('title.ZohoCrmUsers')" @click="tabIndex = 0" lazy>
                    <ZohoUsers />
                </b-tab>
                <b-tab :title="$t('title.ZohoAccounts')" @click="tabIndex = 1" lazy>
                    <ZohoAccounts />
                </b-tab>
                <b-tab :title="$t('title.ZohoDeals')" @click="tabIndex = 2" lazy>
                    <ZohoDeals />
                </b-tab>
                <b-tab :title="$t('title.ZohoLeads')" @click="tabIndex = 3" lazy>
                    <ZohoLeads />
                </b-tab>
                <b-tab :title="$t('title.ZohoPurchaseOrder')" @click="tabIndex = 4" lazy>
                    <ZohoPurchaseOrder />
                </b-tab>
                <b-tab :title="$t('title.ZohoSalesOrder')" @click="tabIndex = 5" lazy>
                    <ZohoSalesOrder />
                </b-tab>

            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import ZohoAccounts from "./ZohoAccounts";
import ZohoDeals from "./ZohoDeals";
import ZohoLeads from "./ZohoLeads";
import ZohoPurchaseOrder from "./ZohoPurchaseOrder";
import ZohoSalesOrder from "./ZohoSalesOrder";
import ZohoUsers from "./ZohoUsers";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

export default {

    components: { ZohoAccounts, ZohoDeals, ZohoLeads, ZohoPurchaseOrder, ZohoSalesOrder, ZohoUsers, Breadcrumbs },
    data() {
        return {
            tabIndex: 0
        };
    },
    created() {
        if(this.$route.query.resource) {
            let resource = this.$route.query.resource.toString();
            if(resource == 'user') {
                this.tabIndex = 0;
            } else if(resource == 'account') {
                this.tabIndex = 1;
            } else if(resource == 'deal') {
                this.tabIndex = 2;
            } else if(resource == 'lead') {
                this.tabIndex = 3;
            } else if(resource == 'purchaseOrder') {
                this.tabIndex = 4;
            } else if(resource == 'salesOrder') {
                this.tabIndex = 5;
            }
        }
    }
};
</script>